// extracted by mini-css-extract-plugin
module.exports = {"albums":"ArtistDiscography_albums__DM3_9"};